import { useGroups } from 'features/groups/hooks/groupsHooks'
import { Group } from 'features/groups'
import { Box, CircularProgress } from '@mui/material'
import GroupsSelector from './GroupsSelector/GroupsSelector'

export function ShareWithGroups({
  selectedGroups,
  onSelectedGroupsChange,
  isShareWithGroupsEnabled,
  isLoading: isMutating,
  disabled,
  readonly
}: {
  selectedGroups: Group[]
  onSelectedGroupsChange: (newGroups: Group[]) => void
  isShareWithGroupsEnabled: boolean
  isLoading?: boolean
  disabled?: boolean
  readonly?: boolean
}) {
  const { data, isLoading } = useGroups()

  if (isLoading) {
    return (
      <Box m={1} display="flex" justifyContent="center" alignItems="center">
        <CircularProgress size={20} />
      </Box>
    )
  }

  if (!isShareWithGroupsEnabled) {
    return null
  }
  if (!data.length) {
    return null
  }

  return (
    <Box>
      <GroupsSelector
        disabled={disabled}
        groups={data}
        isLoading={isMutating}
        selectedGroups={selectedGroups}
        onSelectedGroupsChange={onSelectedGroupsChange}
        readonly={readonly}
      />
    </Box>
  )
}
